<template>
	<v-form v-model="valid" ref="form">

		<v-tabs-items v-model="tab">
			
			<!-- emendas da obra -->
			<v-tab-item value="tabEmendas">
				<!-- <v-decreto-dotacao-list v-model="dotacoesDecretoAnular" :read-only="readOnly" :dotEmenda="true" :dotAnular="true"/> -->
		
				<v-data-table
					v-model="emendasSelecionadas"
					show-select
					:headers="headersEmendas"
					:items="emendasObra"
					class="elevation-1 row-pointer"
					:no-data-text="noDataMessage"
					:items-per-page="itemsPerPage"
					:page.sync="page"
					@pagination="p => (itemsPerPage = p.itemsPerPage)"
					:header-props="{
						sortByText: 'Ordenar por'
					}"
					:footer-props="{
						itemsPerPageText: 'Itens por página:',
						itemsPerPageAllText: 'Todos',
						itemsPerPageOptions: [10, 15, 25, 50, 100, -1]
					}"
					ref="tableEmendas"
					@snack="v => this.$emit('snack',v)"
					item-key="id"
				>
					<template v-slot:[`item.actions`]="{ item }">
						<v-btn
							color="danger"
							small
							@click="removeItem(item)"
							:disabled="readOnly"
						>
							Remover emenda
						</v-btn>
					</template>
					<template
						v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }"
					>
						Exibindo Página de
						{{ Math.floor((pageStart - 1) / itemsPerPage + 1) }} a
						{{ Math.floor(itemsLength / itemsPerPage) + 1 }} <br />
						Itens de {{ pageStart }} a {{ pageStop }} - Total: {{ itemsLength }}
					</template>
				</v-data-table>

				<v-divider></v-divider>
				
				<v-row>
					<v-col md="3" offset-md="3">
					</v-col>
				</v-row>

				<v-col justify-end width="100%">
					<!-- <v-btn color="primary" class="mr-5" @click="exibirTramitar()" v-if="emenda && emenda.id">Tramitar</v-btn> -->
					<v-btn color="primary" class="mr-5" @click="exibirEmenda()">Incluir Emenda</v-btn>
				</v-col>

			</v-tab-item>

			<!-- andamentos da obra -->
			<v-tab-item value="tabAndamentos">

				<v-data-table
					v-model="andamentosSelecionados"
					show-select
					:headers="headersAndamentos"
					:items="andamentosObra"
					class="elevation-1 row-pointer"
					:no-data-text="noDataMessage"
					:items-per-page="itemsPerPage"
					:page.sync="page"
					@pagination="p => (itemsPerPage = p.itemsPerPage)"
					:header-props="{
						sortByText: 'Ordenar por'
					}"
					:footer-props="{
						itemsPerPageText: 'Itens por página:',
						itemsPerPageAllText: 'Todos',
						itemsPerPageOptions: [10, 15, 25, 50, 100, -1]
					}"
					ref="tableEmendas"
					@snack="v => this.$emit('snack',v)"
					item-key="id"
				>
					<template v-slot:[`item.actions`]="{ item }">
						<v-btn
							color="danger"
							small
							@click="removeAndamento(item)"
							:disabled="readOnly"
						>
							Remover andamento
						</v-btn>
					</template>
					<template
						v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }"
					>
						Exibindo Página de
						{{ Math.floor((pageStart - 1) / itemsPerPage + 1) }} a
						{{ Math.floor(itemsLength / itemsPerPage) + 1 }} <br />
						Itens de {{ pageStart }} a {{ pageStop }} - Total: {{ itemsLength }}
					</template>
				</v-data-table>

			
				<v-col justify-end width="100%">
					<!-- <v-btn color="primary" class="mr-5" @click="exibirTramitar()" v-if="emenda && emenda.id">Tramitar</v-btn> -->
					<v-btn color="primary" class="mr-5" @click="exibirAndamento()">Incluir Andamento</v-btn>
				</v-col>

			</v-tab-item>

			<!-- aditivos da obra -->
			<v-tab-item value="tabAditivos">
				<v-data-table
					v-model="aditivosSelecionados"
					show-select
					:headers="headersAditivos"
					:items="aditivosObra"
					class="elevation-1 row-pointer"
					:no-data-text="noDataMessage"
					:items-per-page="itemsPerPage"
					:page.sync="page"
					@pagination="p => (itemsPerPage = p.itemsPerPage)"
					:header-props="{
						sortByText: 'Ordenar por'
					}"
					:footer-props="{
						itemsPerPageText: 'Itens por página:',
						itemsPerPageAllText: 'Todos',
						itemsPerPageOptions: [10, 15, 25, 50, 100, -1]
					}"
					ref="tableEmendas"
					@snack="v => this.$emit('snack',v)"
					item-key="id"
				>
					<template v-slot:[`item.actions`]="{ item }">
						<v-btn
							color="danger"
							small
							@click="removeAditivo(item)"
							:disabled="readOnly"
						>
							Remover Aditivo
						</v-btn>
					</template>
					<template
						v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }"
					>
						Exibindo Página de
						{{ Math.floor((pageStart - 1) / itemsPerPage + 1) }} a
						{{ Math.floor(itemsLength / itemsPerPage) + 1 }} <br />
						Itens de {{ pageStart }} a {{ pageStop }} - Total: {{ itemsLength }}
					</template>
				</v-data-table>

				<v-col justify-end width="100%">
					<!-- <v-btn color="primary" class="mr-5" @click="exibirTramitar()" v-if="emenda && emenda.id">Tramitar</v-btn> -->
					<v-btn color="primary" class="mr-5" @click="exibirAditivo()">Incluir Aditivo</v-btn>
				</v-col>

			</v-tab-item>

		</v-tabs-items>

		<!-- emenda -->
		<v-bottom-sheet persistent width="70%" v-model="solicitarEmenda">
			<v-sheet class="text-center">
				<v-col md="12">
					<v-form v-model="emendaValida" ref="formEmenda">
						<v-row>
							<v-col class="pt-0 pb-0" cols="5" md="2" sm="4">
								<v-text-field
									v-model="anoExercicio"
									:rules="[
										$rules.required(), 
										$rules.between(intervaloAno)
									]"
									label="Ano Exercício"
									required
									type="number"	
									autofocus
								/>
							</v-col>
							<v-col class="pt-0 pb-0" cols="5" md="2" sm="4">
								<v-text-field
									v-model="numeroEmenda"
									:rules="[
										$rules.required(),
										v => (v < 0 ? 'Valor deve ser maior que zero.' : true)
									]"
									label="Número Emenda"
									required
									type="number"
								/>
							</v-col>
							<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
								<v-select
									v-model="esfera"
									:rules="[$rules.required()]"
									:items="esferaItems"
									label="Esfera"
									item-text="descricao"
									item-value="id"
									required
									return-object
								/>
							</v-col>
						</v-row>

					</v-form>
				</v-col>

				<v-row>
					<v-col md="12">
						<v-btn
							class="mr-5"
							outlined
							v-shortkey.once="['esc']"
							@shortkey="cancelarEmenda"
							@click="cancelarEmenda"
						>
							Cancelar
						</v-btn>
						<v-btn
							outlined
							v-shortkey.once="['ctrl', 'enter']"
							@shortkey="enviarEmenda"
							color="primary"
							@click="enviarEmenda"
						>
							Enviar
						</v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-bottom-sheet>

		<!-- andamento -->
		<v-bottom-sheet persistent width="70%" v-model="solicitarAndamento">
			<v-sheet class="text-center">
				<v-col md="12">
					<v-form v-model="andamentoValido" ref="formAndamento">
						<v-row>
							<v-col class="pt-0 pb-0" cols="5" md="2" sm="4">
								<v-text-field
									v-model="dataAfericaoObra"
									:rules="[
										$rules.required(),
										$rules.validDate()
									]"
									label="Data Aferição"
									required
									v-mask="'##/##/####'"	
									autofocus
								/>
							</v-col>
							<v-col class="pt-0 pb-0" cols="5" md="2" sm="4">
								<v-text-field
									v-model="porcentualConcluidoObra"
									:rules="[
										$rules.required()
									]"
									label="Porcentual Concluido"
									required
									type="number"
								/>
							</v-col>

						</v-row>

					</v-form>
				</v-col>

				<v-row>
					<v-col md="12">
						<v-btn
							class="mr-5"
							outlined
							v-shortkey.once="['esc']"
							@shortkey="cancelarAndamento"
							@click="cancelarAndamento"
						>
							Cancelar
						</v-btn>
						<v-btn
							outlined
							v-shortkey.once="['ctrl', 'enter']"
							@shortkey="enviarAndamento"
							color="primary"
							@click="enviarAndamento"
						>
							Enviar
						</v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-bottom-sheet>

		<!-- aditivo -->
		<v-bottom-sheet persistent width="70%" v-model="solicitarAditivo">
			<v-sheet class="text-center">
				<v-col md="12">
					<v-form v-model="aditivoValido" ref="formAditivo">
						<v-row>
							<v-col class="pt-0 pb-0" cols="5" md="2" sm="4">
								<!-- <v-text-field
									v-model="valorAditivo"
									:rules="[
										$rules.required()
									]"
									label="Valor Aditivo"
									type="number"	
									required
									autofocus
								/> -->
								<vuetify-money
									v-model="valorAditivo"
									label="Valor Aditivo"
									:options="{
										locale: 'pt-BR',
										prefix: 'R$',
										suffix: '',
										length: 11,
										precision: 2
									}"
									:properties="{
										rules: [isNumeric],
										required: true,
										'single-line': true
									}"
									required
									autofocus
								/>
							</v-col>
							<v-col class="pt-0 pb-0" cols="7" md="8" sm="8">
								<v-text-field
									v-model="motivoAditivo"
									:rules="[
										$rules.required()
									]"
									label="Motivo Aditivo"
									required
								/>
							</v-col>
						</v-row>
					</v-form>
				</v-col>

				<v-row>
					<v-col md="12">
						<v-btn
							class="mr-5"
							outlined
							v-shortkey.once="['esc']"
							@shortkey="cancelarAditivo"
							@click="cancelarAditivo"
						>
							Cancelar
						</v-btn>
						<v-btn
							outlined
							v-shortkey.once="['ctrl', 'enter']"
							@shortkey="enviarAditivo"
							color="primary"
							@click="enviarAditivo"
						>
							Enviar
						</v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-bottom-sheet>

	</v-form>
</template>

<script>
import { getYear } from 'date-fns';

export default {
	props: ['value', 'tab', 'readOnly', 'diferenca'],
	data() {
		return {
			id: null,
			numeroObra: null,
			dataPrevistaInauguracao: null,
			emendasObra: [],

			valid: null,
			
			emendas: [],
			emendasSelecionadas: [],
			headersEmendas: [
				{ text: 'Nr.', value: 'emenda.numeroEmenda' },
				{ text: 'Ano', value: 'emenda.anoExercicio' },
				{ text: 'Descrição', value: 'emenda.descricao' },
				{ text: 'Secretaria destino', value: 'emenda.secretaria.sigla' },
				{ text: 'Parlamentar', value: 'emenda.parlamentarExercicio.parlamentar.nome' },
				{ text: 'Situação', value: 'emenda.emendaSituacao.descricao' },
				{ text: 'Esfera', value: 'emenda.esfera.descricao' },
				{ text: 'Valor da Emenda (R$)', value: 'valor$' },
				{ text: 'Valor Fixado Final (R$)', value: 'valorFixadoFinal$' },
				{ text: '', value: 'actions', sortable: false }
			],

			andamentos: [],
			andamentosObra: [],
			andamentosSelecionados: [],
			headersAndamentos: [
				{ text: 'Data Aferição', value: 'dataAfericaoObra' },
				{ text: 'Porcentual Concluído', value: 'porcentualConcluidoObra' },
				{ text: '', value: 'actions', sortable: false }
			],

			aditivos: [],
			aditivosObra: [],
			aditivosSelecionados: [],
			headersAditivos: [
				{ text: 'Valor Aditivo', value: 'valorAditivo$' },
				{ text: 'Motivo Aditivo', value: 'motivoAditivo' },
				{ text: '', value: 'actions', sortable: false }
			],

			noDataMessage:
				'Não foram encontradas registros.',
			itemsPerPage: 10,
			page: 1,

			solicitarEmenda: false,
			solicitarAndamento: false,
			solicitarAditivo: false,
			emendaValida : null,
			emenda : null,
			andamentoValido : null,
			aditivoValido: null,
			intervaloAno: {
				start: 1900,
				end: getYear(new Date()) + 4,
				msg: 'Ano inválido. Deve ser entre ${start} e ${end}'
			},

			anoExercicio : null,
			numeroEmenda : null,
			descricaoEmenda: null,
			esfera: null,
			esferaItems : [],

			dataAfericaoObra : null,
			porcentualConcluidoObra : null,

			valorAditivo: null,
			motivoAditivo: null,

			isNumeric: v => isNaN(parseFloat(v)) == false || 'Valor deve ser numérico!'

		};
	},
	
	watch: {
		value(obra) {
			this.id = obra.id;
			//this.numeroDecreto = decreto.numeroDecreto;
			this.dataPrevistaInauguracao = obra.dataPrevistaInauguracao;
			this.numeroObra = obra.numeroObra;
			this.emendasObra = obra.emendasObra;
			this.andamentosObra = obra.andamentosObra;
			
			this.aditivosObra = obra.aditivosObra;
			
			// let aditivosObra = [...this.value.aditivosObra];
			// aditivosObra.forEach(d => {
			// 		d.valorAditivo$ = this.setMascara(d.valorAditivo);
			// });

		},

		aditivosObra() {
			let aditivosObra = [...this.value.aditivosObra];
			aditivosObra.forEach(d => {
					d.valorAditivo$ = this.setMascara(d.valorAditivo);
			});
		},

		$data: {
			handler() {
				this.atualizarValue();
			},
			deep: true
		}

	},

	async created() {
		[
			this.esferaItems
		] = await this.$fetch.getAll([
			`parlamentares/esferas`
		]);
	},

	methods: {

		setMascara(v) {			
			return parseFloat(v).toLocaleString('pt-BR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				style: 'currency',
				currency: 'BRL'
			});
		},

		async salvar() {
			try {

				this.$emit('salvando', true);
				await this.$refs.form.validate();

				let obraSalva;

				if (this.valid) {

					if (this.id) {
						obraSalva = await this.$fetch.put(
							`obras/${this.id}`,
							this.value
						);
						this.$emit('updated', obraSalva);
					} else {
						obraSalva = await this.$fetch.post(`obras`, this.value);
						this.$emit('saved', obraSalva);
					}

				}
				
				return obraSalva;
			
			} catch (err) {
				this.$root.dialog = { title: 'Obra não salva', msg: err.msg };
			} finally {
				this.$emit('salvando', false);
			}
		},

		async remover() {
			try {
				this.$emit('removendo', true);
				let obraRemovida = await this.$fetch.delete(`obras/${this.id}`);
				this.$emit('deleted', obraRemovida);
				this.$emit('removendo', false);
				return obraRemovida;
			} catch (err) {
				this.$root.dialog = { title: 'Obra não Removida', msg: err.msg };
			}
		},

		async obterObra(id) {
			return this.$fetch.get(`obras/${id}`);
		},

		limparCampos() {
			this.$refs.form.reset();
		},

		atualizarValue() {
			this.$emit('input', {
				id: this.id,
				numeroObra: this.numeroObra,
				dataPrevistaInauguracao: this.dataPrevistaInauguracao,
				emendasObra: this.emendasObra,
				andamentosObra: this.andamentosObra,
				aditivosObra: this.aditivosObra
			});
		},

		exibirEmenda() {
			this.solicitarEmenda = true;
		},

		async cancelarEmenda() {
			this.$emit('salvando', false);
			await this.resetEmenda();
			this.solicitarEmenda = false;
		},

		async resetEmenda() {
			//this.emendasObra = null;
			//this.despachoSituacao = null;
			await this.$refs.formEmenda.reset();
		},
		
		async enviarEmenda() {

			try {
				await this.$refs.formEmenda.validate();

				if (this.emendaValida) {

					try {
						// pesquisar se emenda existe   -- colocar esfera
						let emendaAdicionar = await this.$fetch.get('emendas/pesquisarEmenda', {numeroEmenda:this.numeroEmenda, anoExercicio:this.anoExercicio, idEsfera:this.esfera.id});

						this.emendasObra.push({emenda:emendaAdicionar,idEmenda:emendaAdicionar.id,idObra:this.id});

						this.resetEmenda();
						
					} catch (err) {
						this.$root.dialog = { title: 'Emenda não adicionada à obra', msg: err.msg };
					}

					this.solicitarEmenda = false;

				}
			} catch (err) {
				this.$root.dialog = { title: 'Emenda não incluída', msg: err.msg };
			} 
		},

		removeItem(item) {
			this.emendasObra = this.emendasObra.filter(d => d !== item);
		},

////////////////////////////////////////////////////////////

		exibirAndamento() {
			this.solicitarAndamento = true;
		},

		async cancelarAndamento() {
			this.$emit('salvando', false);
			await this.resetAndamento();
			this.solicitarAndamento = false;
		},

		async enviarAndamento() {

			try {
				await this.$refs.formAndamento.validate();

				if (this.andamentoValido) {					

					try {
						// pesquisar se emenda existe   -- colocar esfera
						//let emendaAdicionar = await this.$fetch.get('emendas/pesquisarEmenda', {numeroEmenda:this.numeroEmenda, anoExercicio:this.anoExercicio, idEsfera:this.esfera.id});

						this.andamentosObra.push({dataAfericaoObra:this.dataAfericaoObra,porcentualConcluidoObra:this.porcentualConcluidoObra,idObra:this.id});

					} catch (err) {
						this.$root.dialog = { title: 'Andamento não adicionado à obra', msg: err.msg };
					}

					this.solicitarAndamento = false;

				}
			} catch (err) {
				this.$root.dialog = { title: 'Andamento não incluído', msg: err.msg };
			} 
		},

		async resetAndamento() {
			//this.andamentosObra = null;
			await this.$refs.formAndamento.reset();
		},

		removeAndamento(item) {
			this.andamentosObra = this.andamentosObra.filter(d => d !== item);
		},

////////////////////////////////////////////////////////////

		exibirAditivo() {
			this.solicitarAditivo = true;
		},

		async cancelarAditivo() {
			this.$emit('salvando', false);
			await this.resetAditivo();
			this.solicitarAditivo = false;
		},

		async enviarAditivo() {

			try {
				await this.$refs.formAditivo.validate();

				if (this.aditivoValido) {					

					try {
						// pesquisar se emenda existe   -- colocar esfera
						//let emendaAdicionar = await this.$fetch.get('emendas/pesquisarEmenda', {numeroEmenda:this.numeroEmenda, anoExercicio:this.anoExercicio, idEsfera:this.esfera.id});

						this.aditivosObra.push({valorAditivo:this.valorAditivo,motivoAditivo:this.motivoAditivo,idObra:this.id});

					} catch (err) {
						this.$root.dialog = { title: 'Aditivo não adicionado à obra', msg: err.msg };
					}

					this.solicitarAditivo = false;

					this.resetAditivo()
				}
			} catch (err) {
				this.$root.dialog = { title: 'Aditivo não incluído', msg: err.msg };
			} 
		},

		async resetAditivo() {
			//this.andamentosObra = null;
			await this.$refs.formAditivo.reset();
		},

		removeAditivo(item) {
			this.aditivosObra = this.aditivosObra.filter(d => d !== item);
		}

	}
};
</script>

<style scoped>
.centered-input >>> input {
	text-align: center;
}
.centered-input >>> label {
	right: -50% !important;
	text-align: center !important;
}
.vermelho >>> .v-input__slot {
	background-color: #ff9595 !important;
}
.verde >>> .v-input__slot {
	background-color: #95ff9d !important;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}
/* form >>> *  {
	color: rgba(0, 0, 0, 0.87) !important;
} */
</style>
